import { usePageMeta } from '../hooks/usePageMeta';

export default function SobrePage() {
    usePageMeta({
        title: 'Sobre a Bysetup — Quem somos e nossa missão',
        description: 'Conheça a Bysetup: ajudamos você a escolher o computador certo com listas organizadas por orçamento, comparativos honestos e guias práticos de compra.',
        path: '/sobre'
    });

    return (
        <main>
            
            <section className="py-5" style={{ backgroundColor: '#f8f9fa'}}>
                <div className="container">
                    <h1 className="display-4 fw-bold mb-3">Sobre a Bysetup</h1>
                    <p className="lead text-muted">
                        Conheça nossa missão.
                     </p>
                </div>

            </section>

            <section className="py-5">
                <div className="container">
                    
                    <div className="row g-5">
                        <div className="col-lg-6">
                            <h2 className="fw-bold mb-3">Quem somos</h2>
                            <p className="text-muted mb-3">
                                A Bysetup é uma plataforma dedicada a ajudar pessoas a escolher o melhor computador
                                para suas necessidades, seja para trabalho, estudo ou lazer.
                            </p>
                            <p className="text-muted mb-3">
                                Nascemos com a ideia de simplificar uma decisão complexa: qual computador comprar?
                                Sabemos que existem centenas de opções, marcas, configurações e preços diferentes.
                            </p>
                            <p className="text-muted">
                                Por isso, criamos este espaço para você pesquisar e comparar as melhores opções
                                para você.
                            </p>
                        </div>

                    <div className="col-lg-6">
                        
                        <h2 className="fw-bold mb-3">Nossa missão</h2>
                        <p className="text-muted mb-3">
                            Ajudar você a comprar o computador certo, com confiança e sem arrependimento.
                        </p>
                        <p className="text-muted mb-3">
                            Fazemos isso através de:
                        </p>
                        <ul className="list-unstyled text-muted">
                             <li className="mb-2">✓ Listas organizadas por categoria e orçamento</li>
                            <li className="mb-2">✓ Comparativos honestos entre modelos</li>
                            <li className="mb-2">✓ Guias práticos sobre como escolher</li>
                            <li className="mb-2">✓ Recomendações baseadas em uso e necessidade</li>
                        </ul>
                    </div>
                    </div>

                </div>
            </section>

        </main>
    )
}